var _style, _path, _defs, _defs2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIfixitHeaderLogo20Th = function SvgIfixitHeaderLogo20Th(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    id: "ifixit-header-logo-20th_svg___x32_0_IFIXIT",
    width: 183.882,
    height: 47.788,
    fill: "none",
    style: {
      display: "block"
    }
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2",
    type: "text/css"
  }, ".ifixit-header-logo-20th_svg__st1{fill:#0071ce}.ifixit-header-logo-20th_svg__st3{fill:#b0d100}.ifixit-header-logo-20th_svg__st4{fill:#ff2a51}.ifixit-header-logo-20th_svg__st5{fill:#ffb300}")), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path4",
    d: "M120.316 15.311a1.883 1.883 0 0 0-1.899 1.899v13.76c0 1.062.837 1.9 1.899 1.9 1.061 0 1.898-.84 1.898-1.9V17.21c0-1.06-.84-1.899-1.898-1.899zm-6.684.148h-9.668c-1.06 0-1.898.84-1.898 1.899V30.97c0 1.061.84 1.898 1.898 1.898 1.062 0 1.9-.84 1.9-1.898v-4.93h6.658c.963 0 1.726-.764 1.726-1.727 0-.963-.763-1.726-1.726-1.726h-6.659v-3.674h7.77c.962 0 1.726-.764 1.726-1.727 0-.962-.766-1.728-1.727-1.728zM95.85 15.31a1.883 1.883 0 0 0-1.898 1.899v13.76c0 1.062.84 1.9 1.898 1.9 1.062 0 1.899-.84 1.899-1.9V17.21c0-1.06-.837-1.899-1.899-1.899zm70.583.148h-11.099c-.963 0-1.75.79-1.75 1.75 0 .964.787 1.752 1.75 1.752h3.65v12.01c0 1.061.837 1.898 1.898 1.898s1.899-.84 1.899-1.898V18.963h3.65c.962 0 1.75-.788 1.75-1.751a1.755 1.755 0 0 0-1.748-1.753zm-17.684-.148a1.883 1.883 0 0 0-1.899 1.899v13.76c0 1.062.838 1.9 1.899 1.9s1.899-.84 1.899-1.9V17.21a1.883 1.883 0 0 0-1.899-1.899zm-6.072.737a1.932 1.932 0 0 0-2.736 0l-5.41 5.41-5.41-5.41a1.932 1.932 0 0 0-2.735 0 1.932 1.932 0 0 0 0 2.736l5.41 5.41-5.41 5.409a1.932 1.932 0 0 0 1.368 3.302c.494 0 .99-.188 1.368-.566l5.409-5.41 5.41 5.41c.378.378.873.566 1.368.566a1.932 1.932 0 0 0 1.368-3.303l-5.41-5.409 5.41-5.41a1.932 1.932 0 0 0 0-2.735z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path6",
    d: "M18.057 34.066c14.878-10.76 17.659-13.129 17.659-16.526 0-2.368-2.214-3.604-4.891-3.604-3.656 0-6.539 1.442-9.01 3.758l-4.89-5.869c3.654-4.016 9.112-5.715 13.9-5.715 8.083 0 13.9 4.531 13.9 11.43 0 5.251-3.758 9.73-12.974 15.702h13.231v7.723H18.057v-6.9z",
    className: "ifixit-header-logo-20th_svg__st1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ifixit-header-logo-20th_svg__g24"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "ifixit-header-logo-20th_svg__defs9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__SVGID_1_",
    d: "M67.348 5.782c-9.973 0-18.056 8.083-18.056 18.053 0 9.973 8.083 18.055 18.056 18.055 9.97 0 18.055-8.085 18.055-18.055-.002-9.97-8.085-18.053-18.055-18.053zm5.03 18.814 3.57 4.713c.295.392.313 1.041.038 1.447l-.182.264a5.91 5.91 0 0 1-1.227 1.252l-.43.302c-.398.282-1.045.273-1.435-.025L68 28.976c-.39-.296-1.028-.296-1.42 0l-4.712 3.573c-.39.296-1.042.312-1.442.034l-.312-.215a5.911 5.911 0 0 1-1.242-1.236l-.269-.385c-.28-.4-.269-1.048.027-1.44l3.574-4.715c.295-.392.295-1.03 0-1.42l-3.576-4.715c-.296-.392-.307-1.037-.025-1.437l.305-.43c.282-.401.844-.952 1.25-1.227l.266-.182c.405-.275 1.054-.257 1.444.038l4.713 3.574c.39.295 1.028.295 1.42 0l4.712-3.574c.39-.295 1.053-.333 1.476-.085l.492.291c.424.249.961.804 1.2 1.232l.175.313c.237.428.19 1.098-.107 1.49l-3.57 4.715c-.297.391-.297 1.032 0 1.421z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ifixit-header-logo-20th_svg__SVGID_00000158739017764653375610000010690204822559881149_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifixit-header-logo-20th_svg__SVGID_1_",
    id: "ifixit-header-logo-20th_svg__use11",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ifixit-header-logo-20th_svg__g22",
    clipPath: "url(#ifixit-header-logo-20th_svg__SVGID_00000158739017764653375610000010690204822559881149_)",
    style: {
      clipPath: "url(#ifixit-header-logo-20th_svg__SVGID_00000158739017764653375610000010690204822559881149_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "ifixit-header-logo-20th_svg__defs15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__SVGID_00000021089427590403199400000015969100620815716265_",
    d: "M67.348 5.782c-9.973 0-18.056 8.083-18.056 18.053 0 9.973 8.083 18.055 18.056 18.055 9.97 0 18.055-8.085 18.055-18.055-.002-9.97-8.085-18.053-18.055-18.053z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifixit-header-logo-20th_svg__SVGID_00000021089427590403199400000015969100620815716265_",
    id: "ifixit-header-logo-20th_svg__use17",
    style: {
      overflow: "visible",
      fill: "#0071ce"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ifixit-header-logo-20th_svg__SVGID_00000082330108391535917950000000650589893128204197_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ifixit-header-logo-20th_svg__SVGID_00000021089427590403199400000015969100620815716265_",
    id: "ifixit-header-logo-20th_svg__use19",
    style: {
      overflow: "visible"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ifixit-header-logo-20th_svg__g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path26",
    d: "m40.41 0-1.814 1.767c1.697 1.742 3.86 3.185 4.574 2.49l1.812-1.767c-.712.695-2.884-.758-4.573-2.49z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path28",
    d: "m109.339 40.267-1.578-1.13c-1.085 1.516-1.881 3.344-1.26 3.787l1.578 1.13c-.62-.444.181-2.279 1.26-3.787z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path30",
    d: "m168.138 10.087 2.09 1.274c1.224-2.007 2.056-4.38 1.234-4.88l-2.09-1.274c.822.5-.016 2.883-1.234 4.88z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path32",
    d: "m119.938 5.27-2.22.829c.795 2.132 2.103 4.184 2.976 3.86l2.22-.83c-.873.326-2.184-1.738-2.976-3.86z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path34",
    d: "m141.012 38.218-3.054 1.141c1.095 2.934 2.894 5.757 4.094 5.31l3.054-1.141c-1.2.448-3.005-2.391-4.094-5.31z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path36",
    d: "m82.045.507-2.367.217c.207 2.274.932 4.604 1.862 4.52l2.368-.218c-.93.086-1.656-2.257-1.863-4.52z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path38",
    d: "m18.902 3.292-.67-1.865c-1.792.644-3.522 1.716-3.259 2.45l.67 1.865c-.263-.733 1.477-1.809 3.26-2.45z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path40",
    d: "m60.955 1.492 1.07 1.768c-1.7 1.027-3.704 1.72-4.124 1.026l-1.068-1.768c.42.696 2.432-.005 4.122-1.026z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path42",
    d: "m128.651 40.388-.688-1.144c1.099-.661 2.396-1.107 2.667-.658l.687 1.145c-.27-.45-1.573 0-2.666.657z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path44",
    d: "m156.844 40.282.91-.863c.829.873 1.502 1.972 1.144 2.31l-.91.864c.358-.339-.32-1.442-1.144-2.311z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path46",
    d: "m2.935 8.927 1.801.77c-.74 1.732-1.899 3.376-2.607 3.074L.328 12c.707.303 1.87-1.352 2.607-3.073z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path48",
    d: "m79.978 43.27 1.342.575c-.552 1.289-1.415 2.514-1.942 2.289l-1.342-.575c.527.226 1.394-1.006 1.942-2.289z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path50",
    d: "m8.59 26.017-1.997-2.071c1.99-1.92 4.499-3.482 5.284-2.668l1.997 2.072c-.785-.815-3.304.759-5.283 2.667z",
    className: "ifixit-header-logo-20th_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path52",
    d: "m3.839 30.153 1.225 1.576c-1.513 1.176-3.357 2.07-3.838 1.451L0 31.606c.482.619 2.334-.282 3.839-1.453z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path54",
    d: "m54.829 43.155.424 1.659c-1.593.407-3.35.478-3.517-.174l-.424-1.658c.166.651 1.931.578 3.517.173z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path56",
    d: "m91.712 10.302-1.76-.501c.481-1.69 1.36-3.35 2.052-3.154l1.76.5c-.691-.197-1.574 1.473-2.052 3.155z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path58",
    d: "m105.678 4.44 1.538-.856c.821 1.477 1.351 3.205.747 3.54l-1.537.856c.604-.337.07-2.072-.748-3.54z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path60",
    d: "m160.267 4.57.92 1.478c-1.42.883-3.1 1.49-3.462.91l-.92-1.477c.362.581 2.05-.032 3.462-.91z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path62",
    d: "m38.596 46.108-.527 1.68c-1.614-.506-3.188-1.395-2.982-2.055l.527-1.68c-.207.66 1.376 1.55 2.982 2.055z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path64",
    d: "m183.34 28.067.542 1.935c-1.86.52-3.92.65-4.133-.11l-.541-1.937c.212.76 2.284.628 4.132.112z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path66",
    d: "m137.167 7.953.594 2.002c-1.922.57-4.06.738-4.292-.048l-.594-2.002c.234.787 2.38.615 4.292.048z",
    className: "ifixit-header-logo-20th_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path68",
    d: "m176.428 19.693-.651-1.843c1.77-.625 3.76-.884 4.016-.16l.651 1.842c-.256-.723-2.255-.461-4.016.16z",
    className: "ifixit-header-logo-20th_svg__st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path70",
    d: "m118.557 44.422-.018-2.547c2.448-.018 5.01.51 5.017 1.511l.017 2.548c-.007-1.001-2.582-1.528-5.016-1.512z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path72",
    d: "m174.714 41.819-.105-2.17c2.085-.102 4.287.257 4.33 1.11l.104 2.17c-.042-.852-2.255-1.211-4.329-1.11z",
    className: "ifixit-header-logo-20th_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path74",
    d: "m173.346 31.768-1.442-.193c.185-1.385.686-2.792 1.254-2.716l1.441.192c-.566-.075-1.069 1.339-1.253 2.717z",
    className: "ifixit-header-logo-20th_svg__st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path76",
    d: "m146.159 5.593-1.574 1.974c-1.895-1.513-3.54-3.515-2.92-4.29l1.572-1.973c-.617.775 1.037 2.786 2.922 4.29z",
    className: "ifixit-header-logo-20th_svg__st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path78",
    d: "m6.952 42.627.34 2.573c2.472-.326 4.984-1.219 4.85-2.23l-.34-2.574c.133 1.011-2.392 1.906-4.85 2.23z",
    className: "ifixit-header-logo-20th_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ifixit-header-logo-20th_svg__path80",
    d: "m91.462 37.629-2.147-.166c-.159 2.062.134 4.254.978 4.319l2.147.165c-.843-.065-1.136-2.267-.978-4.319z",
    className: "ifixit-header-logo-20th_svg__st5"
  }))));
};
export default SvgIfixitHeaderLogo20Th;